import { EventDetails, TELEMETRY_TOKEN } from './constants';
import { TangerineBoxEventTrackerForWidget } from "@amzn/tangerinebox-weblib-no-sdk";
import { isConsoleSession, isProdConsole, isESCPartition } from '../utils';
import { SHORTBREAD_VERSION } from '../commit';

/**
 * creates an instance of the TangerineBoxEventTrackerForWidget.
 * @returns an instance of the TangerineBoxEventTrackerForWidget if initialization is successful, null otherwise.
 */
const getTrackerInstance = async () => {
  try {
    const isESC = await isESCPartition();
    const isProd = isProdConsole();

    const token = isESC
      ? (isProd ? TELEMETRY_TOKEN.ESC.PROD : TELEMETRY_TOKEN.ESC.GAMMA)
      : (isProd ? TELEMETRY_TOKEN.AWS.PROD : TELEMETRY_TOKEN.AWS.GAMMA);

    return TangerineBoxEventTrackerForWidget.getInstance({ token });
  } catch (error) {
    console.error('Failed to get tracker instance:', error);
    return null;
  }
}

/**
 * Invokes the telemetry event tracker to log an event.
 * If the user is not in a console session, the function returns early.
 * @param options EventDetails object containing details about the event to be tracked.
 * @returns void
 */
export const trackEvent = async (options: EventDetails) => {
  if (!(await isConsoleSession())) { return; }
  try {
    const eventTracker = await getTrackerInstance();
    if (!eventTracker) { return; }
    const { metric, value, unit, error, details } = options;
    const detailsWithVersion = details ? `${details}, shortbreadVersion: ${SHORTBREAD_VERSION}` : `shortbreadVersion: ${SHORTBREAD_VERSION}`;
    if (error !== undefined && error !== null) {
      eventTracker.addError(error, { metric, value, unit, details: detailsWithVersion });
    } else {
      eventTracker.addEvent({ metric, value, unit, details: detailsWithVersion });

    }
  } catch (error) {

  }
};